/* eslint-disable @typescript-eslint/naming-convention */
import { ITransactionPayment } from '../../../domain/entities/Transaction/Transaction';
import { ITransPaymentResponse } from '../../IApiResponses';
import { enhancePaymentName } from './paymentNameEnhance';

const transactionPaymentsMapper = {
  response(transPayments: ITransPaymentResponse[]): Partial<ITransactionPayment>[] {
    return transPayments.map(item => {
      const {
        balance,
        billing_address_id,
        gc_giftcard_number,
        is_ready_to_complete,
        payment_amount,
        payment_mode,
        payment_type,
        pp_name,
        restrict_card_number,
        trans_payment_id,
      } = item;
      return {
        balance,
        billingAddressId: billing_address_id,
        giftcardNumber: gc_giftcard_number,
        id: trans_payment_id,
        isReadyToComplete: is_ready_to_complete,
        paymentAmount: Number(payment_amount),
        paymentName: enhancePaymentName(pp_name, payment_mode, payment_type),
        paymentType: payment_type,
        restrictCardNumber: restrict_card_number,
      };
    });
  },
};

export default transactionPaymentsMapper;